

































































import Vue from "vue";
import { Component } from "nuxt-property-decorator";
import {
  faUserPlus,
  faAngleDown,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import amplitude from "amplitude-js";
import { Project } from "~/types/project";
import { decrypt } from "~/shared";
import { paymentModuleActive } from "~/config";

@Component({
  name: "ShowcaseNavbarComponent",
  components: {},
})
export default class ShowcaseNavbar extends Vue {
  get faUserPlus() {
    return faUserPlus;
  }

  get faPlus() {
    return faPlus;
  }

  get faAngleDown() {
    return faAngleDown;
  }

  get projectId() {
    const decryptedProjectId = decrypt(
      this.$route.params.project,
      process.env.PROJECT_ID_SALT as string
    );

    return Number(decryptedProjectId);
  }

  get project(): Project | null {
    return this.$store.getters["projects/activeProject"];
  }

  get isAuth() {
    return this.$store.getters.isAuth as boolean;
  }

  get paymentModuleActive() {
    return paymentModuleActive;
  }

  get isPremium(): boolean {
    return this.$store.getters.isPremium;
  }

  get isUnlimited(): boolean {
    return this.$store.getters.isUnlimited;
  }

  get isPremiumV2(): boolean {
    return this.$store.getters.isPremiumV2;
  }

  get isLifelong(): boolean {
    return this.$store.getters.isLifelong;
  }

  get isFree(): boolean {
    return (
      !this.isPremium &&
      !this.isLifelong &&
      !this.isPremiumV2 &&
      !this.isUnlimited
    );
  }

  get projects(): Project[] {
    return this.$store.getters["projects/projects"];
  }

  async onCreateProject() {
    if (this.paymentModuleActive && this.isFree && this.projects.length >= 1) {
      return this.$showPaymentBlocker(
        this.$tc("popups.payment_blocker.too_many_projects.heading"),
        this.$tc("popups.payment_blocker.too_many_projects.btn")
      );
    }

    if (
      this.paymentModuleActive &&
      this.isPremiumV2 &&
      this.projects.length >= 3
    ) {
      return this.$showPaymentBlocker(
        this.$tc("popups.payment_blocker.too_many_projects_premium.heading"),
        this.$tc("popups.payment_blocker.too_many_projects_premium.btn")
      );
    }

    const errorMessage = await this.$store.dispatch(
      "projects/createProjectFromTemplate",
      this.project
    );

    if (errorMessage) {
      this.$notify({ type: "error", message: errorMessage });
      return;
    }

    if (process.client && this.project) {
      amplitude.getInstance().logEvent("project_as_template", {
        projectId: this.project.id,
      });
    }

    this.$notify({
      type: "success",
      message: this.$tc("components.showcase.navbar.success"),
    });

    if (this.project) {
      this.$router.push("/mein-vanausbau/" + this.project.id + "/dashboard");
    }
  }
}
